import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "components/AppIcon";

const quickNavItems = [
  {
    label: "Account Management",
    description: "Manage distributors & retail accounts",
    icon: "Users",
    path: "/account-management",
    color: "#DC2626",
    stat: "1,248 accounts",
  },
  {
    label: "Sales Ordering",
    description: "Place & track field orders",
    icon: "ShoppingCart",
    path: "/sales-ordering-system",
    color: "#D4AF37",
    stat: "47 pending orders",
  },
  {
    label: "Map Visualization",
    description: "Philippine territory heatmap",
    icon: "MapPin",
    path: "/philippine-map-visualization",
    color: "#22C55E",
    stat: "5 regions active",
  },
  {
    label: "Performance Analytics",
    description: "Time comparison & trend analysis",
    icon: "TrendingUp",
    path: "/performance-analytics",
    color: "#D4AF37",
    stat: "Q1 2026 data",
  },
  {
    label: "AI Intelligence",
    description: "AI-powered insights & forecasts",
    icon: "BrainCircuit",
    path: "/ai-intelligence-reports",
    color: "#DC2626",
    stat: "3 new insights",
  },
];

export default function QuickNavPanel() {
  const navigate = useNavigate();

  return (
    <div className="card p-4 md:p-6">
      <div className="mb-4">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground">Quick Navigation</h3>
        <p className="font-caption text-xs text-muted-foreground mt-0.5">Jump to any module</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
        {quickNavItems?.map((item) => (
          <button
            key={item?.path}
            onClick={() => navigate(item?.path)}
            className="flex flex-col items-start p-3 md:p-4 rounded-xl border border-border hover:shadow-md transition-all duration-200 press-effect text-left group"
            style={{ borderColor: 'var(--color-border)' }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = `${item?.color}40`; e.currentTarget.style.boxShadow = `0 4px 20px ${item?.color}15`; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--color-border)'; e.currentTarget.style.boxShadow = ''; }}
          >
            <div
              className="flex items-center justify-center w-10 h-10 rounded-lg mb-3 transition-transform duration-200 group-hover:scale-110"
              style={{ backgroundColor: `${item?.color}18`, border: `1px solid ${item?.color}30` }}
            >
              <Icon name={item?.icon} size={20} color={item?.color} strokeWidth={2} />
            </div>
            <p className="font-heading text-sm font-semibold text-foreground leading-tight">{item?.label}</p>
            <p className="font-caption text-xs text-muted-foreground mt-1 line-clamp-2">{item?.description}</p>
            <div className="mt-2 flex items-center gap-1">
              <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: item?.color }} />
              <span className="font-caption text-xs" style={{ color: item?.color }}>{item?.stat}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}